<template>
    <div class="floating-left" v-if="pagesToHide.indexOf(this.$route.name) < 0">
        <div @click="openCoinTipsDialog()" class="floating-button">
          {{ $t(`label.rewardFreeCoins`) }} <img src="/static/image/cardMania/winning-coin.png" alt="winning" />
        </div>
    </div>
</template>

<script>
import {ROUTE_NAME} from "@/constants/route.constants";

export default {
  name: 'floatingReward',
  props: {
    
  },
  data: () => ({
    pagesToHide : [ROUTE_NAME.REGISTER , ROUTE_NAME.FUNDS]
  }),
  created() {

  },
  methods: {
    openCoinTipsDialog() {
      this.$parent.coinTipsDialog = true
    },
  },
}
</script>


<style lang="scss">
    .floating-left {
        position: fixed;
        display: flex;
        z-index: 5;
        left: 0;
        top: calc(50% - 106px);
        
        .floating-button {
            height: 160px;
            text-align: center;
            background-image: linear-gradient(to right, #70c59e, #368f6b);
            color: #ffffff;
            text-transform: uppercase;
            writing-mode: vertical-lr;
            text-orientation: mixed;
            transform: rotate(180deg);
            padding: 4px;
            top: 0;
            cursor: pointer;

          img {
            width: 32px;
            height: 32px;
            transform: rotate(90deg);
          }
        }
    }
</style>